import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  hasSucceeded: false,
  createEntityRequest: false,
  createEntitySuccess: false,
  createEntityFailure: undefined,
  createdEntity: {},
  cleared: false,
  results: [],
  selected: [],
};

export default reducerFactory(initialState, {
  [types.ENTITIES_LIST_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [types.ENTITIES_LIST_FAILURE]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.response.error,
  }),
  [types.ENTITIES_LIST_SUCCESS]: (state, { response: { entities, paged } }) => ({
    ...state,
    ...entities,
    isLoading: false,
    results: paged ? [...state.results, ...entities.results] : [...entities.results],
  }),
  [types.SELECT_ENTITY]: (state, action) => ({
    ...state,
    selected: [...state.selected, action.response.entity],
  }),
  [types.ADD_SELECTED_ENTITIES]: (state, action) => ({
    ...state,
    selected: action.response.entities,
  }),
  [types.REMOVE_ENTITY]: (state, action) => ({
    ...state,
    selected: state.selected.filter(item => item !== action.response.entity),
  }),
  [types.REMOVE_ALL_ENTITIES]: state => ({
    ...state,
    cleared: true,
    selected: [],
  }),
  [types.CREATE_ENTITY_REQUEST]: state => ({
    ...state,
    createEntityRequest: true,
    createEntitySuccess: false,
    createEntityFailure: false,
  }),
  [types.CREATE_ENTITY_SUCCESS]: (state, { response }) => ({
    ...state,
    createEntityRequest: false,
    createEntitySuccess: true,
    createdEntity: { ...response },
  }),
  [types.CREATE_ENTITY_FAILURE]: (state, { response }) => ({
    ...state,
    createEntityRequest: false,
    createEntityFailure: response.error,
  }),
  [types.MODIFY_ENTITY_REQUEST]: state => ({
    ...state,
    isLoading: true,
    hasSucceeded: false,
    error: undefined,
  }),
  [types.MODIFY_ENTITY_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasSucceeded: true,
    modifiedEntity: { ...response },
    results: state.results.map(result => {
      if (result.id === response.id) {
        return {
          ...response,
        };
      }

      return result;
    }),
  }),
  [types.MODIFY_ENTITY_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.RESET_MODIFIED_ENTITY]: state => ({
    ...state,
    modifiedEntity: undefined,
  }),
  [types.DELETE_ENTITY_REQUEST]: state => ({
    ...state,
    isLoading: true,
    hasSucceeded: false,
    error: undefined,
  }),
  [types.DELETE_ENTITY_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasSucceeded: true,
    deletedEntity: { ...response },
  }),
  [types.DELETE_ENTITY_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
